<template>
  <div
    :id="`${type}-google-button`"
    class="spacing"
  />
</template>



<script>
  import errorHandlers from '@/services/error-handlers';
  import loadScript from 'simple-load-script';
  import returnAppConfig from '@/helpers/return-app-config';
  import signInWithThirdPartyMixin from '@/mixins/sign-in-with-third-party';



  export default {
    name: 'SignInWithGoogle',

    mixins: [signInWithThirdPartyMixin],

    props: {
      type: {
        type: String,
        required: true
      }
    },

    mounted() {
      this.onMounted();
    },

    methods: {
      async onMounted() {
        try {
          await this.loadGoogleIdentityServiceSDK();
          this.initializeSignInButton();
        }
        catch (error) {
          errorHandlers.silent(error);
        }
      },

      async loadGoogleIdentityServiceSDK() {
        if (!window.google?.accounts) await loadScript('https://accounts.google.com/gsi/client');
      },

      initializeSignInButton() {
        window.google.accounts.id.initialize({
          client_id: returnAppConfig().googleApiClientId,
          callback: this.signInSuccessHandler
        });

        window.google.accounts.id.renderButton(
          document.getElementById(`${this.type}-google-button`),
          { width: 260, text: 'continue_with' }
        );
      },

      signInSuccessHandler({ credential }) {
        this.signInWithThirdPartyToken({
          credentials: {
            code: credential,
            type: 'Google'
          }
        });

        // this.$triggerGoogleTrackingEvent('CreateAccountSuccess', 'Account');

        this.$triggerNewRelicEvent('CreateAccountWithGoogle', 'Information', 'Create Account With Google');
      }
    }
  };
</script>
